
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"linkedin\" ><title>linkedin</title><g data-name=\"Layer 2\"><path d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-23a11 11 0 1 0 11 11A11 11 0 0 0 12 1z\"/><path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M9.52 16.51H7.23V9.16h2.29zM8.38 8.16A1.32 1.32 0 1 1 9.7 6.84a1.32 1.32 0 0 1-1.32 1.32zm9.69 8.35h-2.28v-3.57c0-.85 0-1.95-1.19-1.95s-1.37.93-1.37 1.89v3.63H11V9.16h2.19v1A2.4 2.4 0 0 1 15.33 9c2.31 0 2.74 1.52 2.74 3.5z\"/></g></symbol>";
module.exports = sprite.add(image, "linkedin");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linkedin.svg
// module id = 660
// module chunks = 1474